import React from 'react';
import { BRAND, isMarketGB } from '../../constants/main';
import { OfferStyledAC } from './AC/OfferStyled.AC';
import { OfferStyledAP } from './AP/OfferStyled.AP';
import { OfferStyledDS } from './DS/OfferStyled.DS';
import { OfferStyledOV } from './OV/OfferStyled.OV';
import { OfferStyledOVGB } from './OV/OfferStyled.OV.GB';
import { OfferStyled } from './OfferStyled';
import { SC } from '../../styles/theme';
import { Icons } from '../Icon';
import { Event, Place } from '../Tooltip';

export interface OfferProps extends SC {
    text: string;
    tooltipText: string;
    id: string;
    iconName: Icons;
    event?: keyof typeof Event;
    place?: Place;
    index?: number;
    disableFocus?: boolean;
}

const Offer = (props: OfferProps) => {
    if (BRAND === 'AC') return <OfferStyledAC {...props} />;
    if (BRAND === 'OV') return isMarketGB ? <OfferStyledOVGB {...props} /> : <OfferStyledOV {...props} />;
    if (BRAND === 'AP') return <OfferStyledAP {...props} />;
    if (BRAND === 'DS') return <OfferStyledDS {...props} />;
    return <OfferStyled {...props} />;
};

export default Offer;
